import React from "react";

const SchemaMarkup = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "تفریحان",
    "url": "https://www.tafrihan.com/",
    "logo": "https://www.tafrihan.com/static/media/logo-s1.ed56196b3eee34072aa0.png",
    "sameAs": [
      "https://www.instagram.com/tafrihancom",
      "https://www.aparat.com/tafrihan",
      "https://x.com/tafrihan_com",
      "https://www.linkedin.com/in/tafrihan",
      "https://www.pinterest.com/tafrihancom/"
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schemaData),
      }}
    />
  );
};

export default SchemaMarkup;
